/* eslint-disable import/no-cycle */
import React, { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

import MembershipButton from './Membership.Button';
import MembershipHeading from './Membership.Heading';
import MembershipUSP from './Membership.USP';
import MembershipUSPs from './Membership.USPs';

export const MembershipContext = createContext({ withBackground: false });

export default function Membership({
  className = '',
  withBackground = false,
  children,
  ...restProps
}) {
  const contextValue = useMemo(() => ({ withBackground }), [withBackground]);

  return (
    <MembershipContext.Provider value={contextValue}>
      <div
        className={mergeClasses(
          'w-fit rounded-xl',
          {
            'relative bg-[#640CD4] p-6': withBackground
          },
          className
        )}
        {...restProps}
      >
        {withBackground && (
          <div className="z-100 pointer-events-none absolute inset-0 rounded-lg bg-gradient-to-br from-white via-transparent to-white opacity-75" />
        )}
        <div className="space-y-4">{children}</div>
      </div>
    </MembershipContext.Provider>
  );
}

Membership.Button = MembershipButton;
Membership.Heading = MembershipHeading;
Membership.USP = MembershipUSP;
Membership.USPs = MembershipUSPs;

Membership.propTypes = {
  className: PropTypes.string,
  withBackground: PropTypes.bool,
  children: PropTypes.node.isRequired
};

Membership.defaultProps = {
  className: '',
  withBackground: false
};
